import gql from 'graphql-tag';

export const onboardingInvitation = gql`
  mutation onboardingInvitation($input: OnboardingInvitationInput!) {
    onboardingInvitation(input: $input) {
      success
    }
  }
`;
